import { useQuery } from '@tanstack/react-query';
import { apiService } from '../services/api';
import { useTranslation } from '../i18n';

// STD-015: server state for the Documents domain. apiService is imported here
// (a *.queries.ts file) per STD-016. Errors are toasted by the global QueryCache
// handler (lib/queryClient); meta.errorMessage supplies the i18n fallback.
export interface Document {
  id: string;
  title: string;
  description: string | null;
  document_type: string;
  original_filename: string;
  validity_start_date: string | null;
  validity_end_date: string | null;
  file_size: number | null;
  content_type: string | null;
  created_at: string;
}

export const documentKeys = {
  all: ['documents'] as const,
  list: () => [...documentKeys.all, 'list'] as const,
};

export function useDocumentsQuery() {
  const { t } = useTranslation();
  return useQuery({
    queryKey: documentKeys.list(),
    meta: { errorMessage: t('documents.failedToLoad') },
    queryFn: async () => {
      const res = await apiService.listDocuments();
      if (!res.success) throw new Error(res.error || 'Failed to load documents');
      return res.documents;
    },
  });
}
